import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faMessage,
  faSquarePlus,
  faUser,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { ChatContext } from "../../context/ChatContext";
import { AuthContext } from "../../context/AuthContext";
import styles from "./MobileNavigation.module.css";

function MobileNavigation({ handleSetCreatePost }) {
  const { user } = useContext(AuthContext);
  const { unreadCount } = useContext(ChatContext);
  const navLinkClass = ({ isActive }) =>
    `${styles.item} ${isActive ? styles.active : ""}`;

  return (
    <nav className={styles.navigation} aria-label="Navegação móvel">
      <div className={styles.items}>
        <NavLink to="/homepage" className={navLinkClass} aria-label="Feed">
          <FontAwesomeIcon icon={faHouse} aria-hidden="true" />
          <span>Feed</span>
        </NavLink>

        <NavLink to="/messages" className={navLinkClass} aria-label={unreadCount ? `Mensagens, ${unreadCount} não lidas` : "Mensagens"}>
          <FontAwesomeIcon icon={faMessage} aria-hidden="true" />
          <span>Mensagens</span>{unreadCount > 0 && <small className={styles.unreadBadge}>{unreadCount > 99 ? "99+" : unreadCount}</small>}
        </NavLink>

        <button
          type="button"
          className={styles.createButton}
          onClick={() => handleSetCreatePost(true)}
          aria-label="Criar nova postagem"
        >
          <FontAwesomeIcon icon={faSquarePlus} aria-hidden="true" />
        </button>

        <NavLink to="/combine" className={navLinkClass} aria-label="Combinar looks">
          <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden="true" />
          <span>Combinar</span>
        </NavLink>

        <NavLink
          to={`/profile/${user.username}`}
          className={navLinkClass}
          aria-label="Meu perfil"
        >
          <FontAwesomeIcon icon={faUser} aria-hidden="true" />
          <span>Meu perfil</span>
        </NavLink>
      </div>
    </nav>
  );
}

export default MobileNavigation;
